function showSiguide() {
  const opener = document.getElementById('open-size-chart');

  if (!opener) {
    console.warn('Element with id "open-size-chart" not found.');
    return;
  }

  // Preferred: use the native click() if it exists
  if (typeof opener.click === 'function') {
    opener.click();
    return;
  }

  // Fallback: dispatch a MouseEvent (works in older/edge cases)
  const ev = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: true,
    composed: true
  });
  opener.dispatchEvent(ev);
}